<template>
  <div class="autocomplete">
    <input type="text" class="vs-inputx vs-input--input normal" placeholder="Search restaurant products" v-model="productResult">
    <ul class="autocomplete-items">
      <li class="prediction" v-for="(result, i) in searchResults" :key="i" @click="setValue(result)">
        {{ result.name }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    restaurantId: {
      type: Number
    },
    found: {
      type: Function
    }
  },
  name: 'Places',
  data: () => ({
    productResult: '',
    searchResults: [],
    search_break: false
  }),
  watch: {
    productResult (newValue) {
      if (newValue && !this.search_break) {
        this.getProductList()
      }
      if (newValue === '') {
        this.searchResults = []
      }
    }
  },
  methods: {

    getProductList () {
      // Loading

      const payload = {
        restaurantId: this.restaurantId,
        q: this.productResult
      }

      this.$store.dispatch('api/searchProductList', payload)
        .then((response) => {
          this.searchResults = response.data.data

        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    setValue (value) {
      this.searchResults = []
      this.search_break = true
      setTimeout(() => {
        this.search_break = false
      }, 3000)
      this.productResult = ''
      this.found(value)
    },
    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = []
        return
      }
      this.searchResults = predictions.map(prediction => prediction)

      predictions.map(() => {
      })
    }
  }
}
</script>

<style type="scss">
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
  background: white;
}
.autocomplete-items li {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  color: black;
  border-bottom: 1px solid #c3c3c3;
}
.autocomplete-items li:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}
.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}
.autocomplete {
  /*the container must be positioned relative:*/
  position: relative;
  display: inline-block;
}
</style>
